import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './ExameDetalhes.css';

import { API_URL } from '../config';

function ExameDetalhes() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [exame, setExame] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchExameDetalhes();
  }, [id]);

  const fetchExameDetalhes = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await axios.get(`${API_URL}/exames/${id}`);
      setExame(response.data);
    } catch (err) {
      setError('Erro ao carregar dados do exame: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const formatarValor = (value) => {
    if (value === null || value === undefined || value === '') {
      return '-';
    } else if (typeof value === 'boolean') {
      return value ? 'Sim' : 'Não';
    } else if (typeof value === 'string') {
      if (value === 'T' || value === 't') return 'Sim';
      if (value === 'F' || value === 'f') return 'Não';
      return value;
    } else if (typeof value === 'number') {
      return value.toString();
    } else {
      return String(value);
    }
  };

  if (loading) {
    return <div className="loading">Carregando detalhes do exame...</div>;
  }

  if (error) {
    return (
      <div className="error-container">
        <p className="error">{error}</p>
        <button onClick={() => navigate('/exames')} className="back-button">
          Voltar para Exames
        </button>
      </div>
    );
  }

  if (!exame) {
    return <div className="loading">Exame não encontrado</div>;
  }

  // Categorizar campos
  const categorias = {
    'Identificação': ['ID', 'LAUDO', 'SIGLA', 'CODPADRAO'],
    'Descrição': ['DESCRICAO', 'RESULTADO', 'TIPODESCRICAO'],
    'Tipo e Unidade': ['TIPO', 'UNIDADE', 'MASCARA'],
    'Valores': ['VALORPADRAO', 'VALOR_PADRAO_TEXTO', 'MULTPADRAO'],
    'Configurações': ['IMPRIMELAUDO', 'IMPRIMEMAPA', 'MOSTRAREGUA', 'TECLADONUMERICO', 'OBRIGATORIO', 'INTERFACEAR'],
    'Validação': ['ABSURDO_INF', 'ABSURDO_SUP', 'CRITICA_VALOR', 'OPERADOR', 'CONDICAO', 'MENSAGEM'],
    'Fórmula': ['FORMULA'],
    'Referências': ['ID_RESULTADO', 'ID_RESULTADO2', 'ID_VALORREF', 'ID_AGRUP_COMP', 'EXIBIR_VALOR_REF', 'EXIBE_TEXTO_REFERENCIA'],
    'Laboratórios': [
      'CODEXP_REDELAB', 'MULTEXP_REDELAB',
      'CODEXP_RHESUS', 'MULTEXP_RHESUS',
      'CODEXP_RENAL', 'MULTEXP_RENAL',
      'CODEXP_SERGIO_FRANCO', 'MULTEXP_SERGIO_FRANCO',
      'CODEXP_LAB_ALVARO', 'MULTEXP_LAB_ALVARO',
      'CODEXP_AUTOLAC', 'MULTEXP_AUTOLAC',
      'CODEXP_TASY', 'MULTEXP_TASY',
      'CODEXP_CRIESP', 'MULTEXP_CRIESP',
      'CODEXP_CSV', 'MULTEXP_CSV',
      'CODEXP_BITLAB', 'MULTEXP_BITLAB',
      'CODEXP_SMART', 'MULTEXP_SMART',
      'CODEXP_SD2000', 'MULTEXP_SD2000',
      'CODEXP_MATRIX', 'MULTEXP_MATRIX',
      'CODEXP_HOSPITALE', 'MULTEXP_HOSPITALE',
      'CODEXP_SOC',
      'AMOSTRA_ALVARO',
      'MARCAR_VR_CONFERIDO_LABREDE',
      'MARCAR_VR_CONFERIDO_BRASIL_APOIO'
    ],
    'Outros': ['GRAM', 'CLASSIFICACAO_TEXTO', 'POSICAO', 'SEQUENCIAL', 'SENSIBILIDADE']
  };

  const camposCategorizados = {};
  const camposUsados = new Set();

  // Categorizar campos existentes
  Object.entries(categorias).forEach(([categoria, campos]) => {
    const camposEncontrados = campos.filter(campo =>
      exame.hasOwnProperty(campo) && !camposUsados.has(campo)
    );
    if (camposEncontrados.length > 0) {
      camposCategorizados[categoria] = camposEncontrados;
      camposEncontrados.forEach(campo => camposUsados.add(campo));
    }
  });

  // Adicionar campos não categorizados
  const camposNaoCategorizados = Object.keys(exame).filter(key => !camposUsados.has(key));
  if (camposNaoCategorizados.length > 0) {
    camposCategorizados['Não Categorizado'] = camposNaoCategorizados;
  }

  return (
    <div className="exame-detalhes-page">
      <div className="page-header-detalhes">
        <button onClick={() => navigate('/exames')} className="back-button">
          ← Voltar
        </button>
        <h1>Detalhes do Exame</h1>
      </div>

      <div className="exame-info-header">
        <div className="exame-titulo">
          <h2>{exame.DESCRICAO || 'Sem descrição'}</h2>
          <div className="exame-codigo">
            <span className="label">Código:</span>
            <span className="value">{exame.LAUDO}</span>
          </div>
        </div>
      </div>

      <div className="detalhes-grid">
        {Object.entries(camposCategorizados).map(([categoria, campos]) => (
          <div key={categoria} className="info-card">
            <h3>📋 {categoria}</h3>
            <div className="info-grid">
              {campos.map((campo) => {
                const valor = formatarValor(exame[campo]);
                const isLongText = valor.length > 100;
                return (
                  <div key={campo} className={isLongText ? 'info-item full-width' : 'info-item'}>
                    <label>{campo}:</label>
                    <span className={isLongText ? 'long-text' : ''}>{valor}</span>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ExameDetalhes;
